import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsassign } from "../../ui-components";
import LeadsContext from '../../context/leads';


function AssignTable({order, setOrder}) {  
  const {LeadsAsign, models, Subs} = useContext(LeadsContext)
  
  useEffect(()=>{
    LeadsAsign(1,3, order, "register");
    Subs();
  },[order])

  //console.log(models);
  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="assing"/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsassign key={lead.id} leads={lead}  /> :
      <RowLeadsassign key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"}
      }}/> 
    ))}
  </div>

  )
}

export default AssignTable